import { Stack, Typography } from "@mui/material"
import CustomDialog from "components/CustomDialog"
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";

const ShowFault = ({ data, setData }) => {
    const { bt } = useBizTypeTranslation();

    return (
        <CustomDialog
            open={data ? true : false}
            onClose={() => setData(false)}
            title='FAULT'
            closeBtn='CLOSE'
            minWidth={350}
        >
            <Stack alignItems='center'>
                <Typography>{bt(data)}</Typography>
            </Stack>
        </CustomDialog>
    )
}
export default ShowFault